"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Standard = void 0;
const algoTypes_1 = require("./algoTypes");
class Standard {
    type = algoTypes_1.AlgoTypes.standard;
    encrypt;
}
exports.Standard = Standard;
//# sourceMappingURL=standard.js.map